/** @format */

import { Injectable } from '@angular/core';

// Declare the global BV variable
declare const BV: any;

@Injectable({
	providedIn: 'root'
})
export class BazaarvoiceFormService {
	/**
	 * Tells Bazzarvoice script to open the V2 reviews form. If BV script is properly loaded it will open a modal.
	 * If content coach is turned on in the BV portal, suggested review topics will be in the modal.
	 * @param productId the product ecode
	 * @param campaignId the review campaign identifier
	 */
	public openReviewSubmissionV2(productId: string, campaignId?: string) {
		const args = {
			productId,
			...(campaignId && { campaignId })
		};
		this.tryCleanupPreviousForm();
		BV?.ui('rr', 'submit_review', args);
	}

	/**
	 * Workaround that removes the BV form element from the DOM if present so multiple don't stack on repeated invocations
	 * of BV.ui(...). There seems to be a bug in the BV script leaving them behind.
	 */
	private tryCleanupPreviousForm() {
		document?.querySelector('[data-bv-show="inpage_submission"]')?.remove();
	}
}
